import React, { useEffect, useMemo, useState } from "react";
import "./Bankreportprint.css";
import axios from "axios";

import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";

import { Document, Page, Text, View, StyleSheet, PDFViewer } from "@react-pdf/renderer";
import { Font } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

// Register fonts
Font.register({
  family: "Lato-Italic",
  src: LatoItalicFont,
});
Font.register({
  family: "Kannada",
  src: NotoSansKannada,
});

// ✅ styles factory (so fontBase is defined)
const createStyles = (fontBase) =>
  StyleSheet.create({
    page: {
      paddingTop: 20,
      paddingBottom: 20,
      paddingLeft: 20,
      paddingRight: 20,
    },
    pageTable: {
      paddingTop: 30,
      paddingBottom: 20,
      paddingLeft: 20,
      paddingRight: 20,
    },
    table: {
      display: "table",
      width: "100%",
    },

    tableRow: { flexDirection: "row" },
    tableRow2: { flexDirection: "row", backgroundColor: "lightgray" },
    tableRow3: { flexDirection: "row", backgroundColor: "lightgray", marginTop: 10 },

    tableHeader: {
      fontFamily: fontBase,
      fontWeight: "bold",
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderLeftWidth: 1,
      borderRightWidth: 0,
      padding: 0.1,
      flex: 0.29,
      borderColor: "lightblack",
      textAlign: "center",
      fontSize: 12,
    },
    tableHeadersmall: {
      fontFamily: fontBase,
      fontWeight: "bold",
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderLeftWidth: 1,
      borderRightWidth: 0,
      padding: 0.1,
      flex: 0.12,
      borderColor: "lightblack",
      textAlign: "center",
      fontSize: 12,
    },
    tableHeadersmallmedium: {
      fontFamily: fontBase,
      fontWeight: "bold",
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderLeftWidth: 1,
      borderRightWidth: 0,
      padding: 0.1,
      flex: 0.15,
      borderColor: "lightblack",
      textAlign: "center",
      fontSize: 12,
    },
    tableHeadersmallmedium2: {
      fontFamily: fontBase,
      fontWeight: "bold",
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderLeftWidth: 1,
      borderRightWidth: 0,
      padding: 0.1,
      flex: 0.19,
      borderColor: "lightblack",
      textAlign: "center",
      fontSize: 12,
    },
    tableHeaderada: {
      fontFamily: fontBase,
      fontWeight: "bold",
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderLeftWidth: 1,
      borderRightWidth: 1,
      padding: 0.1,
      flex: 0.098,
      borderColor: "lightblack",
      textAlign: "center",
      fontSize: 11,
    },

    tableCellsmall: {
      border: "0.5px solid lightgray",
      padding: 0.5,
      flex: 0.4,
      fontSize: 11,
      fontFamily: fontBase,
      width: 1,
      textAlign: "center",
    },
    tableCell: {
      border: "0.5px solid lightgray",
      padding: 0.5,
      flex: 1,
      fontSize: 11,
      fontFamily: fontBase,
      width: 2,
      textAlign: "center",
    },
    tableCellsmallmediumbranch: {
      border: "0.5px solid lightgray",
      padding: 0.5,
      flex: 0.5,
      fontSize: 10,
      fontFamily: fontBase,
      width: 1,
      textAlign: "center",
    },
    tableCellsmallmedium: {
      border: "0.5px solid lightgray",
      padding: 0.5,
      flex: 0.5,
      fontSize: 11,
      fontFamily: fontBase,
      width: 1,
      textAlign: "center",
    },
    tableCellsmallmedium2: {
      border: "0.5px solid lightgray",
      padding: 0.2,
      flex: 0.7,
      fontSize: 11,
      fontFamily: fontBase,
      width: 1,
      textAlign: "center",
    },
    tableCellada: {
      border: "0.5px solid lightgray",
      padding: 0.5,
      paddingRight: 1,
      flex: 0.3,
      fontSize: 11,
      fontFamily: fontBase,
      width: 0.5,
      textAlign: "right",
    },

    latoText: {
      fontFamily: fontBase,
      fontSize: 14,
      marginBottom: 2,
      textAlign: "center",
      width: "100%",
      fontWeight: "bold",
    },
    latoText2: {
      fontFamily: fontBase,
      fontSize: 11,
      textAlign: "center",
      width: "100%",
      fontWeight: "bold",
    },
    latoTextpara: {
      fontFamily: fontBase,
      fontSize: 11,
      textAlign: "start",
      marginTop: 10,
      width: "100%",
      fontWeight: "bold",
    },
    latoTextparablack: {
      fontFamily: fontBase,
      fontSize: 11,
      textAlign: "start",
      color: "black",
      marginTop: 10,
      width: "100%",
      fontWeight: "bold",
    },
    latoTextpara2: {
      fontFamily: fontBase,
      fontSize: 11,
      textAlign: "start",
      width: "100%",
      marginBottom: 5,
      fontWeight: "bold",
    },
    latoTextparabottom: {
      fontFamily: fontBase,
      fontSize: 11,
      textAlign: "center",
      width: "100%",
      marginBottom: 5,
      marginTop: 100,
      fontWeight: "bold",
    },
    latoTextpararight: {
      fontFamily: fontBase,
      fontSize: 11,
      textAlign: "center",
      width: "100%",
      marginBottom: 5,
      marginLeft: 180,
      marginTop: 15,
      fontWeight: "bold",
    },
  });

const Pregisterprint = () => {
  const { t, i18n } = useTranslation();

  // ✅ fix "lang is not defined"
  const lang = i18n?.language || localStorage.getItem("i18nextLng") || "mr";
  const fontBase = (lang || "").toLowerCase().startsWith("kn") ? "Kannada" : "Lato-Italic";

  // ✅ styles now uses fontBase safely
  const styles = useMemo(() => createStyles(fontBase), [fontBase]);

  // ✅ customerData must be array because you use .length + .slice
  const [customerData, setCustomerData] = useState([]);

  // ---------------- helpers ----------------
  function formatDate(inputDate) {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(inputDate).toLocaleDateString("en-US", options);
  }

  const getDecimals = () => (localStorage.getItem("round") === "on" ? 0 : 2);

  const safeNumber = (v) => {
    const n = Number(String(v ?? 0).replace(/,/g, ""));
    return Number.isFinite(n) ? n : 0;
  };

  const getTotal = (rows) => {
    const decimals = getDecimals();
    const factor = 10 ** decimals;
    const totalUnits = (rows || []).reduce((sum, r) => sum + Math.round(safeNumber(r.ada) * factor), 0);
    return (totalUnits / factor).toFixed(decimals);
  };

  const totalAdaStr =
    Array.isArray(customerData) && customerData.length > 0 ? getTotal(customerData) : (0).toFixed(getDecimals());

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    },
  };

  // ---------------- API load ----------------
  useEffect(() => {
    var mainuser2 = jsEncode.encode("mamapr", 125);

    let rawData = {
      date1: localStorage.getItem("date1print"),
      date2: localStorage.getItem("date2print"),
      bankname: localStorage.getItem("bankname"),
      branch: localStorage.getItem("branch"),
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    };

    rawData = JSON.stringify(rawData);

    let formData = new FormData();
    formData.append("data", rawData);

    axios
      .post("https://excellentdairy.com/dairy/php/cust/getbankreport2.php", formData, {
        "Content-Type": "multipart/form-data",
      })
      .then(function sample(response) {
        // ✅ ensure array
        const arr = Array.isArray(response.data) ? response.data : [];
        setCustomerData(arr);
      })
      .catch((err) => {
        console.log(err);
        setCustomerData([]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const recordsPerPage = 35;
  const totalPages = Math.ceil((customerData?.length || 0) / recordsPerPage);

  return (
    <PDFViewer className="pdf">
      <Document>
        {Array.isArray(customerData) && customerData.length > 0 && (
          <>
            {/* First Page with Introductory Content */}
            <Page size="A4" style={styles.page}>
              <View>
                <Text style={styles.latoText}>{localStorage.getItem("kendra")}</Text>

                <Text style={styles.latoText}>
                  {t("bankreportprint.header.bankLine", {
                    bank: localStorage.getItem("bankname"),
                    branch: localStorage.getItem("branch"),
                  })}
                </Text>

                <Text style={styles.latoText2}>
                  {t("bankreportprint.header.period", {
                    from: formatDate(localStorage.getItem("date1print")),
                    to: formatDate(localStorage.getItem("date2print")),
                  })}
                </Text>

                <Text style={styles.latoText2}>{t("bankreportprint.letter.separator")}</Text>

                <Text style={styles.latoTextpara}>{t("bankreportprint.letter.toLine")}</Text>

                <Text style={styles.latoTextpara2}>
                  {t("bankreportprint.letter.bankNameOnly", { bank: localStorage.getItem("bankname") })}
                </Text>

                <Text style={styles.latoTextparablack}>{t("bankreportprint.letter.subject")}</Text>

                <Text style={styles.latoTextpara}>{t("bankreportprint.letter.body")}</Text>

                <Text style={styles.latoTextparabottom}>{t("bankreportprint.letter.bottomNote")}</Text>

                <Text style={styles.latoTextpararight}>{t("bankreportprint.letter.yoursFaithfully")}</Text>

                <Text style={styles.latoTextpararight}>
                  {t("bankreportprint.letter.kendraOnly", { kendra: localStorage.getItem("kendra") })}
                </Text>

                <Text style={styles.latoTextpara}></Text>
              </View>
            </Page>

            {/* Following Pages with Table Data */}
            {Array.from({ length: totalPages }).map((_, pageIndex) => (
              <Page size="A4" style={styles.pageTable} key={pageIndex + 1}>
                <View style={styles.table}>
                  {/* Table Header */}
                  <View style={styles.tableRow2}>
                    <Text style={styles.tableHeadersmall}>{t("bankreportprint.table.accountNo")}</Text>
                    <Text style={styles.tableHeader}>{t("bankreportprint.table.name")}</Text>
                    <Text style={styles.tableHeadersmallmedium}>{t("bankreportprint.table.branch")}</Text>
                    <Text style={styles.tableHeadersmallmedium}>{t("bankreportprint.table.ifsc")}</Text>
                    <Text style={styles.tableHeadersmallmedium2}>{t("bankreportprint.table.account")}</Text>
                    <Text style={styles.tableHeaderada}>{t("bankreportprint.table.payable")}</Text>
                  </View>

                  {/* Table Data */}
                  {customerData
                    .slice(pageIndex * recordsPerPage, (pageIndex + 1) * recordsPerPage)
                    .map((rowData, index) => (
                      <View key={index} style={styles.tableRow}>
                        <Text style={styles.tableCellsmall}>{rowData.kno}</Text>
                        <Text style={styles.tableCell}>{rowData.cname}</Text>
                        <Text style={styles.tableCellsmallmediumbranch}>{rowData.branch}</Text>
                        <Text style={styles.tableCellsmallmedium}>{rowData.ifsc}</Text>
                        <Text style={styles.tableCellsmallmedium2}>{rowData.accno}</Text>

                        <Text style={styles.tableCellada}>
                          {"₹" + safeNumber(rowData.ada).toFixed(getDecimals())}
                        </Text>
                      </View>
                    ))}
                </View>

                {/* Total row only on last page */}
                {pageIndex === totalPages - 1 && (
                  <View style={styles.table}>
                    <View style={styles.tableRow3}>
                      <Text style={styles.tableHeadersmall}>{t("bankreportprint.table.total")}</Text>
                      <Text style={styles.tableHeader}>{t("bankreportprint.table.dash")}</Text>
                      <Text style={styles.tableHeadersmallmedium}>{t("bankreportprint.table.dash")}</Text>
                      <Text style={styles.tableHeadersmallmedium}>{t("bankreportprint.table.dash")}</Text>
                      <Text style={styles.tableHeadersmallmedium2}>{t("bankreportprint.table.dash")}</Text>
                      <Text style={styles.tableHeaderada}>{"₹" + totalAdaStr}</Text>
                    </View>
                  </View>
                )}
              </Page>
            ))}
          </>
        )}
      </Document>
    </PDFViewer>
  );
};

export default Pregisterprint;
